// extracted by mini-css-extract-plugin
module.exports = {"andt-title":"Title-module__andt-title__1-HMf","page-title":"Title-module__page-title__VQvnT","page-line-counter":"Title-module__page-line-counter__29ayC"};